const ReactDOMServer = require("react-dom/server")
const React = require("react")

const JsonToHtml = (element) => {
  switch (element.type) {
    case "paragraph":
      return <p dangerouslySetInnerHTML={{ __html: element.data.text.replace(/<a\s[^>]*><\/a>/gi, '') }} />
    case "table":
      return (
        <table className={"table"}>
          {element.data.content?.map((item, i) => (
            <tr
              key={i}
              className={"tr"}
            >
              {i === 0 && element.data.withHeadings
                ? item.map((el, i) => (
                    <th
                      key={i}
                      className={"th"}
                      dangerouslySetInnerHTML={{ __html: el }}/>
                  ))
                : item.map((el, i) => (
                    <td
                      key={i}
                      className={"td"}
                      dangerouslySetInnerHTML={{ __html: el }}/>

                  ))}
            </tr>
          ))}
        </table>
      )
    case "list":
      if (element.data.style === "ordered") {
        return (
          <ol className={"ordered"}>
            {element.data.items.map((item, i) => (
              <li
                key={i}
                dangerouslySetInnerHTML={{ __html: item.replace(/<a\s[^>]*><\/a>/gi, '') }}
              />
            ))}
          </ol>
        )
      } else {
        return (
          <ul className={"unordered"}>
            {element.data.items.map((item, i) => (
              <li
                key={i}
                dangerouslySetInnerHTML={{ __html: item.replace(/<a\s[^>]*><\/a>/gi, '') }}
              />
            ))}
          </ul>
        )
      }
    case "image":
      return (
        <img
          src={element.data.file.url}
          alt={element.data.file.alt}
          width={element.data.file.width}
          height={element.data.file.height}
        />
      )

    case "header":
      switch (element.data.level) {
        case 1:
          return <h1 dangerouslySetInnerHTML={{ __html: element.data.text }}/>
        case 3:
          return <h3 dangerouslySetInnerHTML={{ __html: element.data.text }}/>
        case 4:
          return <h4 dangerouslySetInnerHTML={{ __html: element.data.text }}/>
        case 5:
          return <h5 dangerouslySetInnerHTML={{ __html: element.data.text }} />
        case 6:
          return <h6 dangerouslySetInnerHTML={{ __html: element.data.text }}/>
        default:
          return <h2 id={element.id} dangerouslySetInnerHTML={{ __html: element.data.text }}/>
      }
    case "checklist":
      return (
        <div>
          {element.data.items.map((item, index) => (
            <div key={index}>
              <input
                value={item.text}
                checked={item.checked}
                type="checkbox"
              />
              <span  dangerouslySetInnerHTML={{ __html: item.text }} ></span>
            </div>
          ))}
        </div>
      )

    case "warning":
      return (
        <div
          className="warning"
          title={element.data.title}
        >
          <p dangerouslySetInnerHTML={{ __html: element.data.message }}/>
        </div>
      )
    case "code":
      return <pre>{element.data.code}</pre>

    case "raw":
      return <div dangerouslySetInnerHTML={{ __html: element.data.html }} />

    case "quote":
      return (
        <blockquote id={element.id}>
          <div dangerouslySetInnerHTML={{ __html: element.data.text }} />
          <figcaption>
            <em dangerouslySetInnerHTML={{ __html: element.data.caption }} />
          </figcaption>
        </blockquote>
      )
    case "Col":
      return
    case "mediaLib":
      return
    default:
      throw new Error("Type not supported :" + element.type)
  }
}

const arrayToHtml = (data) => {
  let html = `<div class="editorJsContent">`

  data.forEach((item) => {
    switch (item.type) {
      case "HeaderCol":
        html += `<div class="row" ><div class="col">`
        return
      case "CentreCol":
        html += `</div><div class="col">`
        return
      case "FooterCol":
        html += `</div></div>`
        return
      default:
        let res = JsonToHtml(item)
        html += `${ReactDOMServer.renderToString(res)}`
        return
    }
  })

  html += `</div>`
  return html
}

module.exports = { arrayToHtml }
